import React, { FC, useState } from 'react';
import {
  FormControl,
  MenuItem,
  Select,
  SelectChangeEvent,
  Typography,
  Unstable_Grid2 as Grid,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

import { SearchContentFilter } from 'features/admin/types';

interface Props {
  filter: SearchContentFilter;
  setFilter: (filter: SearchContentFilter) => void;
}

enum CTAValues {
  All = 'all',
  Engage = 'engage',
  Share = 'share',
  Both = 'both',
}

const CTAType: FC<Props> = ({ filter, setFilter }) => {
  const { t } = useTranslation();

  const [open, setOpen] = useState(false);

  const [selectValue, setSelectValue] = useState(getInitialValue());

  function getInitialValue() {
    if (filter.is_shareable === undefined && filter.is_engageable === undefined) {
      return CTAValues.All;
    }

    if (filter.is_shareable && filter.is_engageable) {
      return CTAValues.Both;
    }

    if (!filter.is_shareable) {
      return CTAValues.Engage;
    }

    if (!filter.is_engageable) {
      return CTAValues.Share;
    }

    return CTAValues.All;
  }

  function onChange(event: SelectChangeEvent<CTAValues>) {
    const { value } = event.target;
    setSelectValue(value as CTAValues);

    switch (value) {
      case CTAValues.All:
        delete filter.is_shareable;
        delete filter.is_engageable;
        break;
      case CTAValues.Both:
        setFilter({ ...filter, is_shareable: true, is_engageable: true });
        break;
      case CTAValues.Share:
        delete filter.is_engageable;
        setFilter({ ...filter, is_shareable: true });
        break;
      case CTAValues.Engage:
        delete filter.is_shareable;
        setFilter({ ...filter, is_engageable: true });
        break;
    }
  }

  return (
    <Grid xs={12} container marginBottom={1} alignItems="center">
      <Grid xs={3}>
        <Typography variant="body2">{t('admin:CTAType')}</Typography>
      </Grid>
      <Grid xs={8}>
        <FormControl variant="standard">
          <Select
            variant="standard"
            value={selectValue}
            open={open}
            onOpen={() => setOpen(true)}
            onClose={() => setOpen(false)}
            onChange={onChange}
            sx={{ minWidth: 140 }}
          >
            <MenuItem value={CTAValues.All}>{t('common:all')}</MenuItem>
            <MenuItem value={CTAValues.Share}>{t('common:share')}</MenuItem>
            <MenuItem value={CTAValues.Engage}>{t('common:engage')}</MenuItem>
            <MenuItem value={CTAValues.Both}>{t('admin:shareEngage')}</MenuItem>
          </Select>
        </FormControl>
      </Grid>
    </Grid>
  );
};

export default CTAType;
